import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "game-visual" }
const _hoisted_2 = {
  key: 0,
  class: "game-scrim"
}
const _hoisted_3 = {
  key: 1,
  class: "game-footer-backdrop"
}
const _hoisted_4 = {
  key: 2,
  class: "dev-ribbon"
}
const _hoisted_5 = { class: "game-badge" }
const _hoisted_6 = { class: "game-footer" }
const _hoisted_7 = {
  key: 1,
  class: "game-title"
}
const _hoisted_8 = {
  key: 2,
  class: "game-actions"
}
const _hoisted_9 = { class: "btn-enter" }
const _hoisted_10 = {
  key: 0,
  class: "game-description"
}
const _hoisted_11 = { class: "game-title" }
const _hoisted_12 = { class: "game-description-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoBlock = _resolveComponent("InfoBlock")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isInDev ? 'div' : 'router-link'), _mergeProps(_ctx.isInDev ? {} : { to: '/game/' + _ctx.name }, {
    class: ["demo_game", { 'demo_game--split': _ctx.showGameDescription }]
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "game-media",
          style: _normalizeStyle({'background-image': 'url(' + require('@/assets/' + (_ctx.image || _ctx.name) +'.jpg') + ')'})
        }, null, 4),
        (_ctx.showCardScrim)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.showFooterBackdrop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.isInDev)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "in development"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "badge-dot" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.jsonData.tryGame), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_InfoBlock, {
                key: 0,
                name: _ctx.name,
                class: "game-chips"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          (_ctx.showCardTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.game), 1))
            : _createCommentVNode("", true),
          (_ctx.showCardInfoButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.jsonData.cardInfoLabel), 1),
                (_ctx.isAuthenticated)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn-enter btn-enter--coins",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playInCoins && _ctx.playInCoins(...args)), ["stop","prevent"]))
                    }, _toDisplayString(_ctx.jsonData.gamePagePlayCoins), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showGameDescription && !_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.game), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.descriptionText), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["class"]))
}